import { render, staticRenderFns } from "./DialogDuplicateCourse.vue?vue&type=template&id=4292039e"
import script from "./DialogDuplicateCourse.vue?vue&type=script&lang=js"
export * from "./DialogDuplicateCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4292039e')) {
      api.createRecord('4292039e', component.options)
    } else {
      api.reload('4292039e', component.options)
    }
    module.hot.accept("./DialogDuplicateCourse.vue?vue&type=template&id=4292039e", function () {
      api.rerender('4292039e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogDuplicateCourse.vue"
export default component.exports